exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-revolutauth-page{background:#fff;display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%;width:100%}.c-revolutauth-page_content_logo{margin-bottom:60px}.c-revolutauth-page_content_header{color:#112363;text-align:center;margin-bottom:60px;font-size:27px;font-family:BryantWebRegularAlt,Arial,sans-serif}.c-revolutauth-page_content_form{width:340px}.c-revolutauth-page_content_form_error{text-align:center;font-size:14px;color:#f4516c;height:60px;padding-top:15px}.c-revolutauth-page_content_form_button{display:flex;justify-content:center}", ""]);

// exports
